import { RideStatus } from 'features/ippica/types';
import styles from './IppicaLegenda.module.scss';
import { IppicaLegendaItem } from './ippicaLegendaItem';

export const IppicaLegenda = () => {
  return (
    <div className={styles.container}>
      {/* TODO label */}
      <p className={styles.title}>Legenda</p>
      <div className={styles.list}>
        <IppicaLegendaItem type={RideStatus.APERTA} label="aperta" containerClassName={styles.aperta} />
        <IppicaLegendaItem type={RideStatus.CHIUSA} label="chiusa" containerClassName={styles.chiusa} />
        <IppicaLegendaItem type={RideStatus.ANNULLATA} label="ann." containerClassName={styles.annullata} />
        <IppicaLegendaItem type={RideStatus.TOT} label="tot" containerClassName={styles.tot} />
        <IppicaLegendaItem type={RideStatus.TRIS} label="tris" containerClassName={styles.tris} />
        <IppicaLegendaItem type={RideStatus.IN_ATTESA} label="in attesa" containerClassName={styles.attesa} />
        <IppicaLegendaItem type={RideStatus.IN_PAGAMENTO} label="in pagamento" containerClassName={styles.pagamento} />
        <IppicaLegendaItem type={RideStatus.TQQ} label="tris,quartè,quintè" containerClassName={styles.tqq} />
      </div>
    </div>
  );
};
